module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid lead-screen section"
  }, [_c('lead-information', {
    attrs: {
      "carriers": _vm.carriers,
      "details": _vm.leadDetails
    },
    on: {
      "leadUpdate": _vm.leadUpdate,
      "leadCarrierUpdate": _vm.fetchLeadCarriers
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab == 'details'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('details')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _vm._l((_vm.leadCarriers), function(carrier) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link",
      class: {
        active: _vm.activeTab == carrier.leadCarrier_id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActiveTab(carrier)
        }
      }
    }, [_vm._v(_vm._s(carrier.carrier_name))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'details'),
      expression: "activeTab == 'details'"
    }],
    staticClass: "col-holder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('lead-locations', {
    attrs: {
      "lead_id": _vm.$route.params.lead_id
    },
    on: {
      "leadCarrierUpdate": _vm.fetchLeadCarriers
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('lead-contacts', {
    attrs: {
      "details": _vm.leadDetails,
      "leadContacts": _vm.leadContacts
    },
    on: {
      "leadContactsUpdate": _vm.leadContactsUpdate,
      "leadContactsDelete": _vm.leadContactsDelete
    }
  }), _vm._v(" "), _c('lead-notes', {
    attrs: {
      "lead_id": _vm.$route.params.lead_id,
      "details": _vm.leadDetails
    }
  }), _vm._v(" "), _c('lead-files', {
    attrs: {
      "details": _vm.leadDetails
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab != 'details'),
      expression: "activeTab != 'details'"
    }],
    staticClass: "col-holder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [(_vm.activeTab != 'details') ? _c('lead-carrier-notes', {
    attrs: {
      "leadCarrier_id": _vm.leadCarrier_id,
      "details": _vm.leadDetails,
      "carrier_id": _vm.carrier_id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [(_vm.activeTab != 'details') ? _c('lead-carrier-files', {
    attrs: {
      "details": _vm.leadDetails,
      "leadCarrier_id": _vm.leadCarrier_id
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-secondary",
    staticStyle: {
      "margin": "10px auto",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.leadCarrierCreateAccount(_vm.leadCarrier_id)
      }
    }
  }, [_vm._v("Create Account")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72e53959!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/View.vue
// module id = 403
// module chunks = 0